import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import DataTable from 'react-data-table-component'
import {
  exportReportUsingDateAndType,
  getQuizSubmissionsList,
} from '../../../../store/dashboard/actions'
import '../../index.scss'
import { columns, customStyles } from './index'

import Pagination from '../../../../components/UI/Pagination/Pagination'
import downarrowimg from '../../../../assets/images/chevron-down.svg'
import ChildPageHeader from '@/components/UI/ChildPageHeader'
import DateSelect from '@/components/shared/DateSelect'
import dayjs from 'dayjs'
import { Button } from '@mui/material'

const QuizAnalyticsExportSubmission = () => {
  const { t } = useTranslation('translation')
  const dispatch = useDispatch()
  const [filtersData, setFiltersData] = useState({
    filter_from_date: null,
    filter_to_date: null,
    filter_connection_ids: null,
    page: 1,
    page_size: 10,
  })
  const [loading, setLoading] = useState(false)

  const [currentPage, setCurrentPage] = useState(1)
  const [perPage, setPerPage] = useState(10)
  const [paginationState, setPaginationState] = useState(null)
  const [data, setData] = useState([])

  const [dateFilters, setDateFilters] = useState({
    fromDate: null,
    toDate: null,
    dateParameters: null,
  })

  useEffect(() => {
    const filter: any = {
      ...filtersData,
      filter_from_date: dateFilters.fromDate
        ? dayjs(dateFilters.fromDate).format('YYYY-MM-DD')
        : dayjs()
            .subtract(+dateFilters?.dateParameters?.value || 30, 'day')
            .format('YYYY-MM-DD'),
      filter_to_date: dateFilters.toDate
        ? dayjs(dateFilters.toDate).format('YYYY-MM-DD')
        : dayjs(new Date()).format('YYYY-MM-DD'),
    }

    setFiltersData(filter)
  }, [dateFilters])

  useEffect(() => {
    if (
      loading ||
      !(filtersData.filter_from_date || filtersData.filter_to_date)
    ) {
      return
    }
    const fun = async () => {
      await setLoading(true)
      try {
        const data: any = await dispatch(getQuizSubmissionsList(filtersData))
        await setData(data.rows)
        await setPaginationState(data.pagination)
        await setLoading(false)
      } catch (e: any) {
        await setPaginationState([])
        await setLoading(false)
      }
    }
    fun()
  }, [filtersData])

  useEffect(() => {
    const filter = {
      ...filtersData,
      page: currentPage,
      page_size: perPage,
    }
    setFiltersData(filter)
  }, [perPage, currentPage])

  const handlePageChange = async (page: number) => {
    await setCurrentPage(page)
  }

  const onExportTableClick = async () => {
    try {
      const cloned = {
        ...filtersData,
      }
      delete cloned.page
      delete cloned.page_size
      const blob: any = await dispatch(
        exportReportUsingDateAndType('quiz-submissions-list', 'csv', cloned),
      )

      if (!blob) {
        return
      }

      let extension =
        blob &&
        blob.type ==
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          ? 'xlsx'
          : 'csv'
      const url = window.URL.createObjectURL(new Blob([blob]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${'quiz-submissions-list'}.` + extension)
      // 3. Append to html page
      document.body.appendChild(link)
      // 4. Force download
      link.click()
      // 5. Clean up and remove the link
      link.parentNode.removeChild(link)
    } catch (error) {}
  }

  const ChartTableSortIcon = (data: any) => {
    return (
      <img
        src={downarrowimg}
        alt={t('collapsed')}
        className="chart-table-sort-icon"
      />
    )
  }

  return (
    <section className="tw-px-6">
      <div className="mt-3 mb-4">
        <ChildPageHeader title={t('View All Submission')} variant="compact" />

        <div className="tw-flex tw-justify-between">
          <Button variant="outlined" onClick={onExportTableClick}>
            {t('Export Table (CSV)')}
          </Button>
          <DateSelect
            onChange={value => {
              setDateFilters(value)
            }}
          />
        </div>
      </div>
      <React.Fragment>
        <DataTable
          className="table-wraper-trending-questions"
          noContextMenu
          noHeader
          columns={columns()}
          data={data}
          customStyles={customStyles}
          sortIcon={<ChartTableSortIcon />}
        />

        {data && data.length > 0 && paginationState && (
          <Pagination
            currentPage={currentPage}
            pagination={paginationState}
            paginationPerPage={perPage}
            pageChange={(newPerPage: number, page: number) => {
              setPerPage(newPerPage)
              setCurrentPage(1)
            }}
            onChangePage={handlePageChange}
          />
        )}
      </React.Fragment>
    </section>
  )
}
export default QuizAnalyticsExportSubmission
